import MainLayout from "../layout/MainLayout";
import img1 from '../assets/images/page1-1.png'
import img3 from '../assets/images/page1-2.png'
import img4 from '../assets/images/page1-3.png'
import img5 from '../assets/images/page1-4.png'
import img6 from '../assets/images/page3-2.png'
import { Link } from "react-router-dom";

const Home = () => {

    const data = [
        { image: img6, title: "PAYMENT COLLECTION REPORT", link: "/payment-report" }, 
        { image: img4, title: "RENT ARREARS REPORT", link: "/arrears-report" }, 
        { image: img5, title: "STAFF PERSONAL ACCOUNT", link: "/staff-detail" },
        { image: img3, title: "REPOSSESSED UNITS AND CONTRACT TERMINATION", link: "/summary" },
    ]


    return (
        <MainLayout>
            <div className="p-5">
                <Link to="/scanner">
            <div className="flex flex-col items-center justify-center ">
                    <img src={img1} className="w-12 lg:w-10" alt="" />
                    <h3 className=" text-gray-500 text-sm  font-bold uppercase">QR CODE <br/> PENYEWA</h3>
            </div>
                </Link>
            <div className="flex flex-wrap justify-around gap-4 mt-4">
                {data.map((item, index) => (
                    <div key={index} className="w-1/4  flex justify-center">
                        <Link to={item.link}> 
                        <div className="flex flex-col text-center items-center  ">
                            <img src={item.image} className="w-12 lg:w-8 " alt="" />
                            <h3 className=" text-gray-500 text-sm  font-bold">{item.title}</h3>
                        </div>
                        </Link>
                    </div>
                ))}
            </div>
            </div>

        </MainLayout>
    );
}
export default Home;